import { render, staticRenderFns } from "./MenuTip.vue?vue&type=template&id=3324bda6&scoped=true"
import script from "./MenuTip.vue?vue&type=script&lang=js"
export * from "./MenuTip.vue?vue&type=script&lang=js"
import style0 from "./MenuTip.vue?vue&type=style&index=0&id=3324bda6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3324bda6",
  null
  
)

export default component.exports